<template>
  <div class="choose-course">
    <Modal v-model="show" title="选择学生" :footer-hide="true" width="1200">
      <div class="flex">
        <div class="left">
          <div class="search-line">
            <Input
              v-model="searchData.studentName"
              class="search-input"
              placeholder="学生姓名"
              clearable
            ></Input>
            <div class="flex align-items" style="margin-right: 8px">
              {{ yearTermStr }}
            </div>
            <ChooseGradeAndClass
              ref="chooseGradeAndClassRef"
              style="margin-right: 8px"
              :schoolId="schoolId"
              @on-change="onChangeGradeClass"
            ></ChooseGradeAndClass>
            <Select
              v-model="searchData.familyType"
              class="search-input"
              placeholder="全部家庭类型"
              clearable
            >
              <Option
                v-for="item in familyTypeList"
                :key="item.id"
                :value="item.id"
                >{{ item.name }}</Option
              >
            </Select>
            <Button
              type="primary"
              style="margin-right: 8px"
              @click="handleGetSearchValue"
              >搜索</Button
            >
            <Button class="reset-btn" @click="handleResetSearch">重置</Button>
          </div>
          <div class="table">
            <Table
              ref="selection"
              border
              :columns="studentColumn"
              :data="tableList"
              :loading="tableLoading"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all="onSelectAll"
              @on-select-all-cancel="onSelectAllCancel"
              @on-selection-change="onSelectionChange"
            >
              <template slot="courseList" slot-scope="{ row, index }">
                <div class="color-blue cursor-pointer">
                  <Poptip
                    trigger="hover"
                    word-wrap
                    :width="
                      getCourseAllDesc(row.courseList).length > 200 ? 600 : 300
                    "
                    :transfer="true"
                    :content="getCourseAllDesc(row.courseList)"
                  >
                    <span class="click-btn-430">
                      {{ getCourseDesc(row.courseList) }}</span
                    >
                  </Poptip>
                  <!-- <Tooltip
                    max-width="200"
                    :content="getCourseAllDesc(row.courseList)"
                  >
                    <p style="padding: 6px">
                      {{ getCourseDesc(row.courseList) }}
                    </p>
                  </Tooltip> -->
                </div>
              </template>
            </Table>
            <div class="page-main">
              <Page
                :total="coursePageInfo.total"
                show-total
                :current="coursePageInfo.pageNum"
                class="page-right"
                @on-change="handlePageChange"
              ></Page>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="head">选中({{ selectCourseList.length }})</div>
          <div class="right-table">
            <Table
              :columns="rightColumns"
              border
              :data="selectCourseList"
              height="550"
              ><template slot="action" slot-scope="{ row, index }">
                <Button
                  type="error"
                  size="small"
                  @click="handleRemove(row, index)"
                  >删除</Button
                >
              </template></Table
            >
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <Button style="margin-right: 16px" @click="handleCancleBtn"
          >取消</Button
        >
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ChooseAndModal from '@c/ChooseAndModal.vue';

import courseCenter from '@/request/courseCenter/index.js';
import resources from '@/request/courseCenter/resources.js';
import orderCenterApi from '@/request/orderCenter/index.js';
import ChooseGradeAndClass from '@c/searchBlock/ChooseGradeAndClass.vue'

import { gradeStrList, courseLevelStrList } from '@/utils/dictionary.js';

export default {
  components: {
    ChooseAndModal,
    ChooseGradeAndClass
  },
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    couponId: {
      type: String,
      default: ''
    },
    yearTerms: {
      type: Array,
      default: ''
    },
    yearTermStr: {
      type: String,
      default: ''
    },
    classType: {
      type: [Number, Object],
      default: null
    }
  },
  data() {
    return {
      show: false,
      searchData: {
        studentName: '',
        gradeId: '',
        classId: '',
        familyType: '',

      },
      selectCourseList: [], // 选中的课程
      rightColumns: [
        {
          title: '学生姓名',
          key: 'userName'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ], //
      trainingType: '',

      loadingApply: false,
      applyList: [],
      courseType: {
        11: '艺术',
        12: '科技',
        13: '体育',
        14: '美术',
        15: '综合实践',
        21: '早托',
        22: '午托',
        23: '晚托',
        24: '全托'
      },
      familyTypeList: [
        {
          name: '教师子女',
          id: 7
        },
        {
          name: '贫困生',
          id: 8
        }
      ], // 课程类别
      studentColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',

        },
        {
          title: '学生姓名',
          key: 'userName',
          width: 130
        },
        {
          title: '班级',
          key: 'gradeClassName',
          width: 158
        },
        {
          title: '已报课程',
          slot: 'courseList',
          minWidth: 220,
        },

        {
          title: '家庭类型',
          key: 'familyType',
          width: 120,
          render: (h, params) => {
            return h('div', [
              params.row.familyType
                ? this.getFamilyType(params.row.familyType)
                : '--'
            ]);
          }
        },

      ], // 课程商品表格column
      tableList: [], // 课程商品列表
      coursePageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      portOrg: Number(localStorage.getItem('portOrg')),
      tableLoading: false
    };
  },
  watch: {
    classType(newVal) {
      this.searchData.classType = newVal
      console.log(newVal, 'newVal');
    }
  },

  created() { },
  mounted() { },
  methods: {
    init() {
      this.coursePageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.tableList = [];
      this.getStudentList();
    },
    open(productList) {
      this.show = true;
      this.selectCourseList = productList;
      this.init();
    },
    handleCancleBtn() {
      this.show = false;
    },
    // 
    onChangeGradeClass(val) {
      if (val.length == 1) {
        this.searchData.gradeId = val[0]
      } else if (val.length == 2) {
        this.searchData.gradeId = val[0]
        this.searchData.classId = val[1]
      } else {
        this.searchData.gradeId = ''
        this.searchData.classId = ''
      }

    },
    // 提交
    handleSureBtn() {
      // if (this.selectCourseList.length < 2) {
      //   this.$Message.error('至少选择2门课程商品');
      //   return null;
      // }
      this.show = false;
      this.$emit('on-finish', this.selectCourseList);
    },

    getSelectCourseRow(row) {
      console.log(row);
    },
    handlePageChange(page) {
      this.coursePageInfo.pageNum = page;
      this.getStudentList();
    },
    handleOnApplyChange(val) {
      this.searchData.providerId = val.orgId;
    },
    getCourseDesc(list) {
      let str = list.map(item => { return item.classroomName }).join('、')
      return str.length > 20 ? str.substring(0, 20) + '...' : str
    },
    getCourseAllDesc(list) {
      let str = list.map(item => { return item.classroomName }).join('、')
      return str
    },
    //获取家庭类型
    getFamilyType(type) {
      let typeMap = {
        0: '--',
        1: '正常',
        2: '正常',
        3: '正常',
        4: '正常',
        5: '正常',
        6: '正常',
        7: '教师子女',
        8: '贫困生'
      }
      return type ? typeMap[Number(type)] : '--'
    },
    // 获取商品课程列表
    async getStudentList() {
      const params = {
        schoolId: this.schoolId,
        couponId: this.couponId,
        pageNum: this.coursePageInfo.pageNum,
        pageSize: this.coursePageInfo.pageSize
      };
      const paramsTrue = Object.assign(params, this.searchData);
      if (this.yearTerms.length === 2) {
        paramsTrue.yearCode = this.yearTerms[0];
        paramsTrue.termCode = this.yearTerms[1];
      }
      let res;
      //
      this.tableLoading = true;

      res = await orderCenterApi.getCouponsIssuedRangeQueries(paramsTrue);

      this.tableLoading = false;
      if (res.status === 200) {
        this.tableList = res.message.list.map(item => {
          // item.classTimeShow = dealTimeList(item);
          item.id = item.userId;
          return item;
        });
        this.coursePageInfo.total = Number(res.message.total);
        this.handletableList();
      }
    },
    handleGetSearchValue() {
      this.coursePageInfo.pageNum = 1;
      this.coursePageInfo.total = 0;
      this.getStudentList();
    },
    handleResetSearch() {
      for (let k in this.searchData) {
        this.searchData[k] = ''
      }
      this.$refs.chooseGradeAndClassRef.handleClear()
      this.handleGetSearchValue()
    },
    onSelectionChange(selection, row) { },
    onSelectCancel(selection, row) {
      const key = this.selectCourseList.findIndex(item => {
        return item.userId == row.userId;
      });
      if (key != -1) {
        this.selectCourseList.splice(key, 1);
      }
    },
    onSelectAll(selection) {
      selection.forEach(item => {
        this.onSelect(selection, item);
      });
    },
    onSelectAllCancel(selection) {
      this.tableList.forEach(item => {
        this.onSelectCancel(selection, item);
      });
    },
    onSelect(selection, row) {
      const key = this.selectCourseList.findIndex(item => {
        return item.userId == row.userId;
      });
      if (key == -1) {
        this.selectCourseList.push(row);
      }
    },
    // 删除
    handleRemove(row, index) {
      this.selectCourseList.splice(index, 1);
      this.handletableList();
    },
    // 处理列表选中效果
    handletableList() {
      this.tableList.forEach(item => {
        item._checked = false;
        const key = this.selectCourseList.findIndex(item_1 => {
          return item_1.userId == item.userId;
        });
        if (key != -1) {
          item._checked = true;
        }
      });
      this.tableList = Object.assign([], this.tableList);
    },


  }
};
</script>

<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.iconTips {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin: 0 0 10px 10px;
  width: 600px;
  height: 30px;
  background-color: #fffae2;
  border: solid 1px #ffe184;
}
.page-main {
  text-align: right;
  padding: 16px 0;
}
.flex {
  display: flex;
  .left {
    width: 70%;
    margin-right: 20px;
  }
  .right {
    width: 28%;
    .head {
      background: rgba(0, 0, 0, 0.05);
      padding: 8px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
.modal-footer {
  text-align: right;
  padding: 10px 0;
}
</style>
